import axios from 'axios';
import { useUserStore } from '@stores/User';

const api = axios.create({ baseURL: `${location.origin}/api/` })
api.defaults.withCredentials = false;

// Set default headers for all requests
axios.defaults.headers.common['Accept'] = 'application/json'; // Set Accept header to indicate JSON response
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

const getCookies = () => {
    return document.cookie.split(';').reduce((cookies, cookie) => {
        const [name, value] = cookie.trim().split('=');
        cookies[name] = value;
        return cookies;
    }, {});
};

// Add a request interceptor
api.interceptors.request.use(
    function(config) {
        // Do something before request is sent
        // For example, you can modify headers or add tokens

        const user = useUserStore();

        if (user.isLoggedIn()) {
            config.headers['Authorization'] = `Bearer ${user.token}`;
        }

        // Usage
        const cookies = getCookies();
        const token = cookies['XSRF-TOKEN']?.replace('%3D', '=');
        if (token) {
            config.headers['X-XSRF-TOKEN'] = token;
        }

        return config;
    },
    function(error) {
        // Do something with request error
        return Promise.reject(error);
    }
);

api.interceptors.response.use(function (response) {
    // good stuff
    return response;
}, function(error) {
    // bad stuff
    const response = error?.response;
    if (response?.status === 401) {
        const user = useUserStore();
        if (!response?.config?.url.includes('logout')) {
            user.logout();
        }
        return;
    }

    if (response?.status === 419) {
        const user = useUserStore();
        if (!response?.config?.url.includes('logout')) {
            user.logout();
        }
    }

    throw error;
});

export { axios, api }
